<template>
  <div>
    <div v-for="(comment, index) in repliedCommetslist" :key="comment._id" style="position:relative">
      <comments
        :commentDetails="comment"
        :enableMinimalData="true"
        :reviewDetails="reviewInfo"
        @checkIsUnsavedDescriptionComment="checkIsUnsavedDescription"
        @replyCommentDelete="deletingReplyComment"
        :idOfParentComment="parentCommentId != null ? parentCommentId : ''"
        :commentModule="commentModule"
        @openPictureInPicture="openPictureInPicture"
        @openManageVersions="openManageVersions"
      ></comments>
      <div :key="index" v-if="index == 0 && repliedCommetslist.length>1" style="position: absolute;background: #1e1e1e;width: 64px;display: inline-block;text-align: center;z-index: 9;inset-inline-start :calc(50% - 32px);bottom: -10px;"> Replies</div>
    </div>
  </div>
</template>
<script>
import comments from "./comments.vue";

export default {
  methods:{
      openPictureInPicture(info){
          this.$emit("openPictureInPicture",info)
      },
      openManageVersions(file){
        this.$emit("openManageVersions",file)
      },
      deletingReplyComment(deletingCommentInfo){
          this.$emit("replyCommentDelete", deletingCommentInfo)
      },

      checkIsUnsavedDescription(){
        if(this.enableEditMode == true && this.updatedDescrption != this.previousDescription && this.updatedDescrption!= null && this.previousDescription != null){
            if(confirm(
              `Unsaved Description is there, Do you want to save it ?`
            )){
              // this.updateTaskFields('description',this.description);
              this.$emit("descriptionUpdate", {"isUpdateDescription":true});
            }else{
              this.$emit("descriptionUpdate", {"isUpdateDescription":false});
              // this.description = this.previousDescription;
              // this.isDescriptionEditing = false;
            }
        }
        
      },
  },
  props:["repliedCommetslist", "reviewInfo", "parentCommentId", "commentModule", "enableEditMode", "previousDescription", "updatedDescrption"],
  components:{
      "comments":comments
  }
};
</script>
